import { render, staticRenderFns } from "./sound-element.vue?vue&type=template&id=75d4f823&scoped=true"
import script from "./sound-element.vue?vue&type=script&lang=js"
export * from "./sound-element.vue?vue&type=script&lang=js"
import style0 from "./sound-element.vue?vue&type=style&index=0&id=75d4f823&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d4f823",
  null
  
)

export default component.exports